import { useEntityType } from 'hooks';
import { ENTITY, PATH_TO_ENTITY_MAP } from 'modules/campaigns/config';
import { useSupplyTargetingFormField } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/hooks/useSupplyTargetingFormField';
import { useCreativeCampaignData } from 'modules/campaigns/modules/creative-creator/hooks/useCreativeCampaignData';
import { isAppleTargeting } from 'modules/campaigns/modules/creative-creator/utils/isAppleTargeting';
import { SUPPLY_TARGETING_TYPES } from '../SupplyTargeting/const';

export const useIsAppleTargetingByEntity = () => {
    const entityType = useEntityType(PATH_TO_ENTITY_MAP);
    const { value: supplyTargetingFormFieldValue } = useSupplyTargetingFormField();
    const { fetchedCampaign: campaignOfCreative } = useCreativeCampaignData();

    const isSupplyTargetingApple =
        (entityType === ENTITY.CAMPAIGN && supplyTargetingFormFieldValue === SUPPLY_TARGETING_TYPES.APPLE_NEWS) ||
        isAppleTargeting(campaignOfCreative);

    return isSupplyTargetingApple;
};
